
import { Component, Prop, Vue } from 'vue-property-decorator';
import BottomWrapper from '@/views/Chatroom/BottomWrapper.vue';
import CheckIcon from '@/components/icons/CheckIcon.vue';
import * as Locale from '@/plugins/i18n';
import { analytics } from '@/common/logs';
import { PAGE_EVENTS, BTN_EVTS } from '@/common/logs/events';

@Component({
  components: {
    BottomWrapper,
    CheckIcon,
  },
})
export default class TicketConfirmation extends Vue {
  @Prop({ required: true }) readonly ticketId!: string;
  @Prop({ required: true }) readonly email!: string;

  readonly Locale = Locale;

  get buttons () {
    return [
      {
        name: this.$t('page.confirmation.ticket_created.close'),
        id: 'close',
        isActive: true,
      },
    ];
  }

  created () {
    document.title = 'Ticket Created';

    // Track ticket confirmation page view
    analytics.trackPageEvent({
      name: PAGE_EVENTS.GUEST_TICKET_CONFIRMATION,
      enter: true,
      metadata: {
        ticketId: this.ticketId,
        email: this.email,
      },
    });
  }

  handleAction ({ id }: { id: string }) {
    if (id === 'close') {
      // Track close button click
      analytics.trackClick({
        name: BTN_EVTS.GUEST_TICKET_CONFIRMATION_CLOSE,
        metadata: {
          ticketId: this.ticketId,
          email: this.email,
        },
      });

      this.$emit('close');
    }
  }
}
